const FooterLangTextA: any = {
    us: {
        PrivacyPolicy: 'Privacy Policy',
        TermsOfUse: 'Terms of Use',
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
        email_desc: '',
        select_country: 'Select your country or region:',
        privacyTerms: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://us.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://us.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/us/data-security-and-privacy',
            },
        ],
        copywrite: 'Copyright © 2025 EcoFlow Technology Inc. All Rights Reserved.',
    },
    // 2
    ca: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://ca.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://ca.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Other Policies',
                link: 'https://ca.ecoflow.com/pages/policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/ca/data-security-and-privacy',
            },
            {
                text: 'Compliance Statement',
                link: 'https://account.ecoflow.com/agreement/en-ca/Statement.html',
            },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 3
    eu: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            {
                text: 'Who We Are',
                link: 'https://www.ecoflow.com/eu/about-us',
            },
            {
                text: 'Contact Us',
                link: 'https://www.ecoflow.com/eu/contact-us',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html',
            },
            {
                text: 'Terms of Service',
                link: 'https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/eu/data-security-and-privacy',
            },
            {
                text: 'Compliance Statement',
                link: 'https://account.ecoflow.com/agreement/en-eu/Statement.html',
            },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 4
    uk: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 5
    de: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 6
    fr: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 7
    it: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 8
    es: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 9
    jp: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 10
    kr: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 11
    cn: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 12
    tw: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 13
    au: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 14
    za: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 15
    sa: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 16
    mx: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 17
    br: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
    // 18
    ph: {
        select_country: 'Select your country or region:',
        privacyPolicy: [
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
            { text: '', link: '' },
        ],
        copywrite: 'Copyright © 2025 EcoFlow All Rights Reserved.',
    },
};

export default FooterLangTextA;
